export default __webpack_public_path__ + "static/media/RUBRIQUEKOJY-SOLVE.4475f56f.png";